import axiosInstance from './axios';

export interface Prediction {
  id: string;
  name: string;
  status: string;
  attributes: {
    land_preparation_date: string;
    transplant_date: string;
  };
  recommendations: {
    recommendation_date: string;
  };
  createdAt: string;
  product?: {
    logo?: string;
    name?: string;
  };
}

export interface CreatePredictionRequest {
  productId: string;
  location: {
    latitude: string;
    longitude: string;
  };
  attributes: {
    land_preparation_date: string;
    transplant_date: string;
  };
  name: string;
  userId: string;
  cropId: string;
}

export const predictionsApi = {
  getUserPredictions: async (userId: string, filters?: {
    productId?: string;
    status?: string;
    date?: string;
  }) => {
    const queryParams = new URLSearchParams();
    if (filters?.productId) queryParams.append('productId', filters.productId);
    if (filters?.status) queryParams.append('status', filters.status);
    if (filters?.date) queryParams.append('date', filters.date);

    const url = `/predictions/userPredictions/${userId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await axiosInstance.get(url);
    return response.data;
  },

  getPredictionDetails: async (predictionId: string) => {
    const response = await axiosInstance.get(`/predictions/${predictionId}`);
    return response.data;
  },

  createPrediction: async (data: Omit<CreatePredictionRequest, 'attributes'> & {
    attributes: Partial<CreatePredictionRequest['attributes']>;
  }) => {
    const response = await axiosInstance.post('/predictions/', data);
    return response.data;
  },
}; 